export default __webpack_public_path__ + "static/media/React-removebg-preview.a8853fc8.png";